export const getTranslateX = (element: HTMLElement): number => {
	const transform = getComputedStyle(element).transform
	if (!transform || transform === 'none') return 0

	const match = transform.match(/matrix.*\((.+)\)/)
	if (!match?.[1]) return 0

	return parseFloat(match[1].split(', ')[4] || '0')
}
